import { useState } from 'react';
import { Box, TextField, Typography, Button } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import CustomAppBar from '../components/CustomAppBar';
import PrimaryButton from '../components/PrimaryButton';
import Navbar from '../components/Navbar';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import CloseIcon from '@mui/icons-material/Close';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { addHeart, addHeartToReduxAndServer } from '../redux/heartSlice';
import { updateTitle, updateSubtitle } from '../redux/doneSlice';
import { createHeartOnServer } from '../api/api';
// Utils
import { generateUniqueHeartId } from '../validation/utils';
// Validation
import { Formik, ErrorMessage, Field, Form } from 'formik';
import { heartNameSchema } from '../validation/schemas';
import { HeartSchema, UserSchema } from 'lumas-shared-schemas';
import { addUserToReduxAndServer } from '../redux/userSlice';
import { EMPTY_GROUP_ID } from '../constants';


function AddHeartName() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const hearts = useSelector((state) => state.heart.hearts);
    const user = useSelector((state) => state.user.user);
    const tempHeart = useSelector((state) => state.heart.tempHeart);


    const handleFormSubmit = async (values, {setSubmitting}) => {
        console.log("Values", values);
        setSubmitting(false); 

        const heartId = tempHeart.id;
        console.log("Heart ID", heartId);

        // Create new heart on server, and validate heart object against schema in lumas-shared-schemas
        const newHeart = HeartSchema.parse({ 
            ...tempHeart,
            name: values.name,
            group: EMPTY_GROUP_ID,
            status: 'Online',
            owner: user.email
        });
        console.log("NEW HEART", newHeart);
        
        // update the User's hearts array, validating against schema
        const updatedUser = UserSchema.parse({
            ...user,
            hearts: [...user.hearts, heartId]
        });

        // Dispatch AFTER validation to prevent inconsistent DB state
        dispatch(addHeartToReduxAndServer(newHeart));
        dispatch(addUserToReduxAndServer(updatedUser));

        // for Done screen
        dispatch(updateTitle(`${values.name} successfully added!`));
        dispatch(updateSubtitle("You can now view your new heart on the home page."))
        navigate('/add-heart/done');
    };

    return (
        <AppContainer>
            <Formik
                initialValues={{ name: ''}}
                validationSchema={heartNameSchema}
                onSubmit={handleFormSubmit}
            >
        {({ isSubmitting, errors, touched }) => (
          <Form>

            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>
                <CustomAppBar />
                {/* Box to fill space, pushing button to bottom of screen */}
                <Box style={{ flex: 1 }}>
                    <Navbar rightButtonIcon={<CloseIcon />} rightButtonOnClick={() => {navigate('/home')}} />
                    <TextContainer>
                        <Typography variant='h5'>Name the heart</Typography>
                        <Field 
                            as={TextField}
                            id='name'
                            name='name'
                            sx={{width: '100%', marginTop: '20px'}} 
                            label="Heart Name"
                            variant="filled" 
                            required
                            error={errors.name && touched.name}
                        />
                        <ErrorMessage name="name" component="div" style={{ color: 'red' }} />
                    </TextContainer>
                </Box>
                {/* Button at the bottom of the screen */}
                <TextContainer customStyles={{marginBottom: '40px'}}>
                    <PrimaryButton text={"Done"} customStyles={{width: '100%'}} />
                </TextContainer>
            </Box>
          </Form>
        )}
        </Formik>
        </AppContainer>
    )
}

export default AddHeartName